/* ============================================================
   WEATHER ICON SVG
============================================================ */
import React, { memo } from "react";

const WeatherIconSVG = memo(({ code, size = 15 }) => {
  if (code === 0) {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      >
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M6.3 17.7l-1.4 1.4M19.1 4.9l-1.4 1.4" />
      </svg>
    );
  }

  if (code >= 51 && code <= 67) {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      >
        <path d="M20 16.5A5 5 0 0 0 18 7h-1.2A8 8 0 1 0 4 15.2" />
        <path d="M8 19v2M12 19v2M16 19v2" />
      </svg>
    );
  }

  if (code >= 71 && code <= 86) {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      >
        <path d="M20 16.5A5 5 0 0 0 18 7h-1.2A8 8 0 1 0 4 15.2" />
        <path d="M8 19l-1 2M12 19l-1 2M16 19l-1 2" />
      </svg>
    );
  }

  if (code >= 95) {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      >
        <path d="M19 16.5A5 5 0 0 0 18 7h-1.2A8 8 0 1 0 3 16" />
        <path d="M13 11l-4 6h4l-2 5" />
      </svg>
    );
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    >
      <path d="M18 10h-1.2A8 8 0 1 0 3 16.2h15a5 5 0 0 0 0-10z" />
    </svg>
  );
});
WeatherIconSVG.displayName = "WeatherIconSVG";

export default WeatherIconSVG;